// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { startKeepAlive } from "./utils/keepAlive";

// Start pinging backend to prevent Render free tier from sleeping
startKeepAlive();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
